import data from '@/data/airplane.json';
import dayjs from 'dayjs';

export function getAirplaneStaticInfo(no: string) {
  return (
    data as Record<
      string,
      {
        company?: string;
        model?: string;
        startPosition?: string;
        endPosition?: string;
        duration?: string;
        startTime?: string;
        endTime?: string;
        stay?: string;
      }
    >
  )[no];
}

export function getTwoAirplaneTimeBetween({
  no,
  no2,
  date,
}: {
  no: string;
  no2: string;
  date: string;
}) {
  const info = getAirplaneStaticInfo(no);
  const info2 = getAirplaneStaticInfo(no2);
  if (!info?.endTime || !info2?.startTime) return undefined;

  // const startTime = formatDayExtra({ time: info.endTime, date });
  // const endTime = formatDayExtra({ time: info2.startTime, date });

  // 计算总分钟数的差异
  const diffMinutes = dayjs(`${date} ${info2.startTime}`).diff(
    dayjs(dayjs(`${date} ${info.endTime.replace('+1', '')}`)),
    'minute'
  );

  // 将总分钟数转换为小时和分钟
  const hours = Math.floor(diffMinutes / 60);
  const minutes = diffMinutes % 60;

  return {
    hours,
    minutes,
  };
}

export function getIsDifferentTerminal({
  no,
  lastNo,
}: {
  no: string;
  lastNo: string;
}) {
  const info = getAirplaneStaticInfo(no);
  const info2 = getAirplaneStaticInfo(lastNo);
  return info2?.endPosition !== info?.startPosition;
}
